import {
  paginateURL,
  advancedSearchURL,
  quickSearchURL,
  expandURL,
} from 'services/url';
import { createApiCall } from 'services/api';
import { FetchItemsHandler } from '../types';
import _ from 'lodash';
import { searchLikeURL, searchTermURL } from 'services/url/search';
import {
  urlContainsNewApiStandardsEndpoint,
  urlContainsOldApiStandardsEndpoint,
} from './helpers';
import { paginateV2URL } from 'services/url/pagination';

export const fetchItems: FetchItemsHandler = async (
  url,
  dataAdapter,
  currentState,
  quickSearchColumns
) => {
  let path = url;
  const advancedSearch = currentState.advancedSearch;

  //new endpoints have different rules
  if (urlContainsOldApiStandardsEndpoint(url)) {
    path = searchTermURL(
      path,
      currentState.quickSearch,
      quickSearchColumns,
      advancedSearch
    );
  } else if (urlContainsNewApiStandardsEndpoint(url)) {
    path = searchLikeURL(
      path,
      currentState.quickSearch,
      quickSearchColumns,
      advancedSearch
    );
  } else {
    // quick search URL using received quick search
    path = quickSearchURL(
      path,
      currentState.quickSearch,
      quickSearchColumns,
      advancedSearch
    );
  }

  // advanced search URL using received advanced search
  path = advancedSearchURL(path, currentState.advancedSearch);

  // expand URL if there is expand field
  if (currentState.expand) {
    path = expandURL(path, currentState.expand);
  }

  // paginate URL if pagination was sent
  if (currentState.pagination) {
    if (urlContainsNewApiStandardsEndpoint(url)) {
      path = paginateV2URL(path, currentState.pagination);
    } else {
      path = paginateURL(path, currentState.pagination);
    }
  }

  const itemsResponse = await createApiCall(
    { path, method: 'GET' },
    {
      getMessage: {
        error: (error: any) =>
          error.response.data.message ||
          'Something went wrong when we where trying to load items. Please try again in few minutes.',
      },
    }
  )();

  return {
    results: itemsResponse.data.results.map(dataAdapter),
    totalResults: itemsResponse.data.maxResults,
  };
};
